var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "selectOidcGroupModal",
        size: "lg",
        "hide-header-close": "",
        "no-stacking": "",
        title: _vm.$t("admin.select_oidc_group"),
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function ({ cancel }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "secondary" },
                  on: {
                    click: function ($event) {
                      return cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.cancel")))]
              ),
              _c(
                "b-button",
                {
                  attrs: { size: "md", variant: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.$emit("selection", _vm.$refs.table.getSelections())
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("message.select")))]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("bootstrap-table", {
        ref: "table",
        attrs: { columns: _vm.columns, data: _vm.data, options: _vm.options },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }